/* eslint-disable jsx-a11y/alt-text */
import React from 'react'
import Diamond from './ð¿ðµñ‡ð°ñ‚ñœ-134036857.jpg'
import styles from './Notfound.module.css'

export default function Notfound() {
  return (
    <>

        <div className='m-auto  mt-5'>
            <img src={Diamond} className={`${styles.imageWidth}`} />
        </div>
    </>
  )
}
